// extracted by mini-css-extract-plugin
export var container = "_1d-0";
export var disabled = "_1d-4";
export var fullWidth = "_1d-3";
export var lined = "_1d-1";
export var selected = "_1d-5";
export var tab = "_1d-2";